import React from "react";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { LinkToNewTab } from "../../Elements/Link/Link.js";
import { useUser } from "../../../contexts/userContext/userContext.js";

export const AboutSection = () => {
  const { getTextByKey } = useContent();
  const { getUserData } = useUser();
  return (
    <div className="footer-about">
      <div className="footer-section-title">
        {getTextByKey("about-jumbomail")}
      </div>
      <LinkToNewTab page={"about"}>{getTextByKey("about-us")}</LinkToNewTab>
      <LinkToNewTab page="terms">{getTextByKey("terms-of-use")}</LinkToNewTab>
      {/* {(getUserData().UserCountry === "Israel" ||
        getUserData().UserCountry === undefined) && (
        <LinkToNewTab page="jumbo-pay-terms">
          {getTextByKey("jumbopay-terms")}
        </LinkToNewTab>
      )} */}
      <LinkToNewTab page="jumbo-pay-terms">
        {getTextByKey("jumbopay-terms")}
      </LinkToNewTab>
      <LinkToNewTab page="privacy-policy">
        {getTextByKey("privacy-policy")}
      </LinkToNewTab>
      <LinkToNewTab page="accessibility">
        {getTextByKey("accessibility")}
      </LinkToNewTab>
    </div>
  );
};
